import React from "react";

import { ORDER_DETAIL_V2_COMPONENT_MAPPER } from "./ComponentMapper";
import { COMPONENT_TRANSFORMER } from "./ComponentTransformer";
import { useOrderDetailV2 } from "./OrderDetailV2Context";
import type { ComponentMapperType, ComponentRendererProps } from "./types";

export const ComponentRenderer: React.FC<ComponentRendererProps> = ({
  components,
  layout,
  mapper: customMapper,
}) => {
  const ctx = useOrderDetailV2();
  const mapperToUse: ComponentMapperType =
    customMapper || ORDER_DETAIL_V2_COMPONENT_MAPPER;
  const mapper = mapperToUse[layout] || {};

  if (!components) {
    return null;
  }

  return (
    <>
      {components.map((card, index) => {
        const CardComponent = mapper[card.id];
        const transformer = COMPONENT_TRANSFORMER[card.id];

        if (!CardComponent) {
          return null;
        }

        const key = card.id;
        const transformedData = transformer
          ? transformer(card.data, ctx)
          : card.data;

        if (!transformedData || typeof transformedData !== "object")
          return null;

        return <CardComponent key={key} {...transformedData} />;
      })}
    </>
  );
};

export default ComponentRenderer;
